import { ToastRegion } from '@repo/design-system-kit';

export function FlashMessages(): React.ReactElement {
  return (
    <div data-test-flash-message-stack>
      <ToastRegion />
    </div>
  );
}
